import { IColumn as IOfficeColumn } from "@fluentui/react";
import React from "react";
import styled from "styled-components";
import { AuxRenderProps, IActionPromise } from "../../LegacyDetailsList/cell-renderers";
import { renderArrayCell } from "./renderArrayCell";
import { renderBooleanCell } from "./renderBooleanCell";
import { renderDateCell } from "./renderDateCell";
import { renderEmptyCell } from "./renderEmptyCell";
import { renderFavoriteQueryCell } from "./renderFavoritesCell";
import { renderFormattedCell } from "./renderFormattedCell";
import { renderIconAndTextCell } from "./renderIconAndTextCell";
import { renderIconOnlyCell } from "./renderIconOnlyGridCell";
import { renderObjectCell } from "./renderObjectCell";
import { renderOdataCell } from "./renderOdataCell";
import { renderRemediationCell } from "./renderRemediationCell";
import { RenderCellFn, RenderCellFnArgs } from "./types";

const renderChain: Array<RenderCellFn> = [
  renderRemediationCell,
  renderFavoriteQueryCell,
  renderBooleanCell,
  renderIconOnlyCell,
  renderIconAndTextCell,
  renderEmptyCell,
  renderOdataCell,
  renderArrayCell,
  renderObjectCell,
  renderDateCell,
  renderFormattedCell,
];

export default function renderGridCell(
  item: any,
  index: number,
  column: IOfficeColumn | undefined,
  onItemClicked?: IActionPromise,
  auxProps?: AuxRenderProps,
  readOnly?: boolean
) {
  if (!column) {
    return null;
  }
  const renderArgs: RenderCellFnArgs = { item, index, column, onItemClicked, auxProps, readOnly };
  for (let i = 0; i < renderChain.length; i++) {
    const cell = renderChain[i](renderArgs);
    if (cell !== null) {
      return cell;
    }
  }
  return <UnknownTitle>UNKNOWN</UnknownTitle>;
}

const UnknownTitle = styled.h2`
  color: red;
`;
